<template>
	<div class="category-breakdown" :class="`category-breakdown--${variant}`">
		<div v-for="row in rows" :key="row.key" class="category-breakdown__row">
			<span class="category-breakdown__label">
				<span v-if="variant === 'legend'" class="category-breakdown__swatch" :style="{ backgroundColor: row.color }"></span>
				{{ row.label }}
			</span>

			<v-progress-linear v-if="variant === 'bars'" class="category-breakdown__bar" :model-value="row.ratio * 100" :color="row.color" bg-color="grey-lighten-2" :bg-opacity="1" :height="10" rounded />

			<span class="category-breakdown__figures">
				{{ row.formatted }}
				<span v-if="row.share !== null" class="category-breakdown__share">· {{ formatPercent(row.share) }}</span>
			</span>
		</div>
	</div>
</template>

<script setup>
import { formatPercent } from '@/utils/core/format';

defineProps({
	rows: { type: Array, default: () => [] },
	variant: { type: String, default: 'legend' },
});
</script>

<style scoped lang="scss">
@use '@/styles/variables' as *;

.category-breakdown {
	display: flex;
	flex-direction: column;
	gap: 8px;
	min-width: 0;

	&__row {
		display: flex;
		align-items: center;
		gap: 12px;
		min-width: 0;
	}

	&__label {
		display: flex;
		align-items: center;
		gap: 8px;
		min-width: 0;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-size: $font-size;
	}

	&__swatch {
		flex: 0 0 auto;
		width: 12px;
		height: 12px;
		border-radius: 50%;
	}

	&__bar {
		flex: 1 1 auto;
		min-width: 60px;
	}

	&__figures {
		margin-left: auto;
		flex: 0 0 auto;
		font-size: $font-size-small;
		white-space: nowrap;
	}

	&__share {
		color: rgba(var(--v-theme-on-surface), 0.68);
	}

	&--bars &__label {
		flex: 0 0 auto;
		width: 150px;
	}

	&--bars &__figures {
		width: 120px;
		text-align: right;
	}
}
</style>
